import React from 'react'
import {Lang} from 'yougile-lang'
import {BooleanFilter, BooleanFilterValue} from './boolean-filter'
import {DateFilter, DateFilterValue} from './date-filter'
import {Filter} from './filter'
import {LocationFilter, LocationFilterValue} from './location-filter'
import {StickerFilter, StickerFilterValue} from './sticker-filter'
import {TimerFilter, TimerFilterValue} from './timer-filter'
import {
  TimetrackingFilter,
  TimetrackingFilterValue
} from './timetracking-filter'
import {UserFilter, UserFilterValue} from './user-filter'
import {TextFilter, TextFilterValue} from './text-filter'
import {ChatFilter, ChatFilterValue} from './chat-filter'
import {getLocationFilterRows} from './location-filter-rows'

export const located: Filter = {
  key: 'located',
  getName: () => Lang.msg.taskLocation,
  getGroupTitle: () => Lang.msg.report.locationStatusGroup,
  getEl: (filter, update) => (
    <LocationFilter filters={filter.located} update={update('located')} />
  ),
  getRows(filter) {
    const {rows, tree} = getLocationFilterRows(filter?.located ?? [])
    if (!tree.length) {
      return 0
    }
    return Math.max(1, rows.length)
  },
  linesPerRow: 2,
  getSelectedValue: filter => {
    return <LocationFilterValue filters={filter.located} />
  }
}

export const isCompletedFilter: Filter = {
  key: 'isCompleted',
  getName: () => Lang.msg.statFilterCompleteness,
  getGroupTitle: () => Lang.msg.report.locationStatusGroup,
  getEl: (filter, update) => (
    <BooleanFilter
      key="isCompleted"
      filter={filter.isCompleted}
      update={update('isCompleted')}
      yesText={Lang.msg.statsCompleteCompleted}
      noText={Lang.msg.statsCompleteNotCompleted}
    />
  ),
  getSelectedValue: filter => {
    return (
      <BooleanFilterValue
        filter={filter.isCompleted}
        yesText={Lang.msg.statsCompleteCompleted}
        noText={Lang.msg.statsCompleteNotCompleted}
      />
    )
  }
}

export const isArchivedFilter: Filter = {
  key: 'isArchived',
  getName: () => Lang.msg.statFilterArchiveness,
  getGroupTitle: () => Lang.msg.report.locationStatusGroup,
  getEl: (filter, update) => (
    <BooleanFilter
      key="isArchived"
      filter={filter.isArchived}
      update={update('isArchived')}
      yesText={Lang.msg.statArchivenessYes}
      noText={Lang.msg.statArchivenessNo}
    />
  ),
  getSelectedValue: filter => {
    return (
      <BooleanFilterValue
        filter={filter.isArchived}
        yesText={Lang.msg.statArchivenessYes}
        noText={Lang.msg.statArchivenessNo}
      />
    )
  }
}

export const createdAtFilter: Filter = {
  key: 'createdAt',
  getName: () => Lang.msg.statsFilterCreatedAt,
  getGroupTitle: () => Lang.msg.report.datesGroup,
  getEl: (filter, update) => (
    <DateFilter
      key="createdAt"
      filter={filter.createdAt}
      update={update('createdAt')}
    />
  ),
  getSelectedValue: filter => {
    return <DateFilterValue filter={filter.createdAt} />
  }
}

export const movedAtFilter: Filter = {
  key: 'movedAt',
  getName: () => Lang.msg.statsFilterMoveDate,
  getGroupTitle: () => Lang.msg.report.datesGroup,
  getEl: (filter, update) => (
    <DateFilter
      key="movedAt"
      filter={filter.movedAt}
      update={update('movedAt')}
    />
  ),
  getSelectedValue: filter => {
    return <DateFilterValue filter={filter.movedAt} />
  }
}

export const lastMessageAtFilter: Filter = {
  key: 'lastMessageAt',
  getName: () => Lang.msg.statsFilterLastMessage,
  getGroupTitle: () => Lang.msg.report.datesGroup,
  getEl: (filter, update) => (
    <DateFilter
      key="lastMessageAt"
      filter={filter.lastMessageAt}
      update={update('lastMessageAt')}
    />
  ),
  getSelectedValue: filter => {
    return <DateFilterValue filter={filter.lastMessageAt} />
  }
}

export const completedAtFilter: Filter = {
  key: 'completedAt',
  getName: () => Lang.msg.statCompletedAt,
  getGroupTitle: () => Lang.msg.report.datesGroup,
  getEl: (filter, update) => (
    <DateFilter
      key="completedAt"
      filter={filter.completedAt}
      update={update('completedAt')}
    />
  ),
  getSelectedValue: filter => {
    return <DateFilterValue filter={filter.completedAt} />
  }
}

export const createdByFilter: Filter = {
  key: 'createdBy',
  getName: () => Lang.msg.statsFilterCreatedBy,
  getGroupTitle: () => Lang.msg.report.usersGroup,
  getEl: (filter, update) => (
    <UserFilter
      key="createdBy"
      filters={filter.createdBy}
      update={update('createdBy')}
    />
  ),
  getSelectedValue: filter => {
    return <UserFilterValue filters={filter.createdBy} />
  }
}

export const assignedByFilter: Filter = {
  key: 'assignedBy',
  getName: () => Lang.msg.statsFilterAssignedBy,
  getGroupTitle: () => Lang.msg.report.usersGroup,
  getEl: (filter, update) => (
    <UserFilter
      key="assignedBy"
      filters={filter.assignedBy}
      update={update('assignedBy')}
    />
  ),
  getSelectedValue: filter => {
    return <UserFilterValue filters={filter.assignedBy} />
  }
}

export const assignedToFilter: Filter = {
  key: 'assignedTo',
  getName: () => Lang.msg.statsFilterAssignedTo,
  getGroupTitle: () => Lang.msg.report.usersGroup,
  getEl: (filter, update) => (
    <UserFilter
      key="assignedTo"
      filters={filter.assignedTo}
      update={update('assignedTo')}
    />
  ),
  getSelectedValue: filter => {
    return <UserFilterValue filters={filter.assignedTo} />
  }
}

export const responsibleFilter: Filter = {
  key: 'responsible',
  getName: () => Lang.msg.statsFilterResponsible,
  getGroupTitle: () => Lang.msg.report.usersGroup,
  getEl: (filter, update) => (
    <UserFilter
      key="responsible"
      filters={filter.responsible}
      update={update('responsible')}
    />
  ),
  getSelectedValue: filter => {
    return <UserFilterValue filters={filter.responsible} />
  }
}

export const deadlineFilter: Filter = {
  key: 'deadline',
  getName: () => Lang.msg.statsFilterDeadline,
  getGroupTitle: () => Lang.msg.report.stickersGroup,
  getEl: (filter, update) => (
    <DateFilter
      key="dealine"
      filter={filter.deadline}
      update={update('deadline')}
      isDeadline={true}
      canBeInFuture={true}
    />
  ),
  getSelectedValue: filter => {
    return <DateFilterValue filter={filter.deadline} />
  }
}

export const timetrackingFilter: Filter = {
  key: 'timetracking',
  getName: () => Lang.msg.timetracking,
  getGroupTitle: () => Lang.msg.report.stickersGroup,
  getEl: (filter, update) => (
    <TimetrackingFilter
      filter={filter.timetracking}
      update={update('timetracking')}
    />
  ),
  getSelectedValue: filter => {
    return <TimetrackingFilterValue filter={filter.timetracking} />
  }
}

export const timerFilter: Filter = {
  key: 'timer',
  getName: () => Lang.msg.timer,
  getGroupTitle: () => Lang.msg.report.stickersGroup,
  getEl: (filter, update) => (
    <TimerFilter
      key="timer"
      filter={filter.timer}
      update={update('timer')}
      stopwatch={false}
    />
  ),
  getSelectedValue: filter => {
    return <TimerFilterValue filter={filter.timer} />
  }
}

export const stopwatchFilter: Filter = {
  key: 'stopwatch',
  getName: () => Lang.msg.stopwatch,
  getGroupTitle: () => Lang.msg.report.stickersGroup,
  getEl: (filter, update) => (
    <TimerFilter
      key="stopwatch"
      filter={filter.stopwatch}
      update={update('stopwatch')}
      stopwatch={true}
    />
  ),
  getSelectedValue: filter => {
    return <TimerFilterValue filter={filter.stopwatch} />
  }
}

export const stickersFilter: Filter = {
  key: 'stickers',
  getName: () => Lang.msg.statsFilterStickers,
  getGroupTitle: () => Lang.msg.report.stickersGroup,
  getEl: (filter, update) => (
    <StickerFilter filter={filter.stickers} update={update('stickers')} />
  ),
  getRows: filter => Math.max(1, Object.keys(filter?.stickers ?? {}).length),
  getSelectedValue: filter => {
    return <StickerFilterValue filter={filter.stickers} />
  }
}

export const subtasksFilter: Filter = {
  key: 'subtasks',
  getName: () => Lang.msg.component.subtasksFilters.subtasks,
  getGroupTitle: () => Lang.msg.report.subtasks,
  getEl: (filter, update) => (
    <BooleanFilter
      filter={filter.subtasks}
      update={update('subtasks')}
      yesText={Lang.msg.component.subtasksFilters.subtasksYes}
      noText={Lang.msg.component.subtasksFilters.subtasksNo}
    />
  ),
  getSelectedValue: filter => {
    return (
      <BooleanFilterValue
        filter={filter.subtasks}
        yesText={Lang.msg.component.subtasksFilters.subtasksYes}
        noText={Lang.msg.component.subtasksFilters.subtasksNo}
      />
    )
  }
}

export const subtasksDeadlineFilter: Filter = {
  key: 'subtasksDeadline',
  getName: () => Lang.msg.component.subtasksFilters.deadline,
  getGroupTitle: () => Lang.msg.report.subtasks,
  getEl: (filter, update) => (
    <DateFilter
      filter={filter.subtasksDeadline}
      update={update('subtasksDeadline')}
      isDeadline={true}
      canBeInFuture={true}
    />
  ),
  getSelectedValue: filter => {
    return <DateFilterValue filter={filter.subtasksDeadline} />
  }
}

export const subtasksAssignedFilter: Filter = {
  key: 'subtasksAssigned',
  getName: () => Lang.msg.component.subtasksFilters.assigned,
  getGroupTitle: () => Lang.msg.report.subtasks,
  getEl: (filter, update) => (
    <UserFilter
      filters={filter.subtasksAssigned}
      update={update('subtasksAssigned')}
    />
  ),
  getSelectedValue: filter => {
    return <UserFilterValue filters={filter.subtasksAssigned} />
  }
}

export const subtasksCompletedFilter: Filter = {
  key: 'subtasksCompleted',
  getName: () => Lang.msg.component.subtasksFilters.completed,
  getGroupTitle: () => Lang.msg.report.subtasks,
  getEl: (filter, update) => (
    <BooleanFilter
      filter={filter.subtasksCompleted}
      update={update('subtasksCompleted')}
      yesText={Lang.msg.component.subtasksFilters.completedYes}
      noText={Lang.msg.component.subtasksFilters.completedNo}
    />
  ),
  getSelectedValue: filter => {
    return (
      <BooleanFilterValue
        filter={filter.subtasksCompleted}
        yesText={Lang.msg.component.subtasksFilters.completedYes}
        noText={Lang.msg.component.subtasksFilters.completedNo}
      />
    )
  }
}

export const textFilter: Filter = {
  key: 'text',
  getName: () => Lang.msg.component.textFilter.text,
  getGroupTitle: () => Lang.msg.report.miscGroup,
  getEl: (filter, update) => (
    <TextFilter filter={filter.text} update={update('text')} />
  ),
  getSelectedValue: filter => {
    return <TextFilterValue filter={filter.text} />
  }
}

export const chatFilter: Filter = {
  key: 'chat',
  getName: () => Lang.msg.component.chatFilter.chat,
  getGroupTitle: () => Lang.msg.report.miscGroup,
  getEl: (filter, update) => (
    <ChatFilter filter={filter.chat} update={update('chat')} />
  ),
  getSelectedValue: filter => {
    return <ChatFilterValue filter={filter.chat} />
  }
}
